import { render } from "./BackgroundImage.vue?vue&type=template&id=2928bf12&scoped=true"
import script from "./BackgroundImage.vue?vue&type=script&lang=ts"
export * from "./BackgroundImage.vue?vue&type=script&lang=ts"

import "./BackgroundImage.vue?vue&type=style&index=0&id=2928bf12&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2928bf12"

export default script